/**
 * used to determine if code is running in server context
 * false if
 */
export const isServerSide = (): boolean => typeof window === 'undefined'
